import { useEffect } from "react";
import "./index.css";

const BubblesBg = () => {
  useEffect(() => {}, []);

  const bubbleBgs = [
    "dark-sky-blue",
    "hot-pink",
    "peachy",
    "orange",
    "peachy-pink",
    "peachy-pink-no-highlight",
    "sky-blue",
  ];

  const noOfBubbles = 10;

  const randomInt = (minInt, maxInt) => {
    minInt = minInt ? minInt : 0;
    maxInt = maxInt ? maxInt : 100;
    return Math.floor(Math.random() * (maxInt - minInt + 1) + minInt);
  };

  const randomBubbleBg = () => {
    let randomBubbleImageRef = bubbleBgs[randomInt(0, bubbleBgs.length - 1)];
    let fullUrl = `/images/bubble-bgs/${randomBubbleImageRef}.jpg`;
    return fullUrl;
  };

  const Bubble = ({ index }) => {
    let animationDelay = `${index * 3}s`;
    let widthAndHeight = (randomInt(25) / 100) * 200 + "px";
    let randomBubbleBgUrl = randomBubbleBg();
    return (
      <div
        className="rise absolute z-10 rounded-full"
        style={{
          width: widthAndHeight,
          height: widthAndHeight,
          left: `${randomInt()}%`,
          bottom: `-100px`,
          animationDelay,
        }}
      >
        <div
          className="float  rounded-full relative w-full h-full cursor-pointer transition-all duration-300  "
          style={{
            backgroundImage: `url(${randomBubbleBgUrl})`,
            backgroundPosition: "center",
            backgroundSize: "102%",
            animationDelay,
          }}
        ></div>
      </div>
    );
  };

  return (
    <div
      className="w-full h-full top-0 left-0 opacity-80 pointer-events-none"
      style={{ position: "fixed", zIndex: 1 }}
    >
      {[...Array(noOfBubbles)].map((e, i) => (
        <Bubble key={i} index={i} />
      ))}
    </div>
  );
};

export default BubblesBg;
